module.exports = __webpack_public_path__ + "static/media/logo192.b9665122.png";